var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crip-notice-content",class:{
       'crip-notice-with-icon': _vm.withIcon,
       'crip-notice-with-desc': _vm.withDesc,
     }},[(_vm.withIcon)?_c('span',{staticClass:"crip-notice-icon",class:[("crip-notice-icon-" + _vm.type)]},[_c('i',{class:[("" + (_vm.icons[_vm.type]))]})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"crip-notice-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"crip-notice-desc",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-646595ab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoticeContent.vue
// module id = 22
// module chunks = 0